export const clearState = () => {
    localStorage.removeItem('NCPstate');
}

export const loadState = () => {

    try {

        const serializedState = localStorage.getItem('Kasvurahoitus');
        
        if (serializedState === null) {
            return undefined;
        }
        let state = JSON.parse(serializedState);
        
        // Clean up auth state
        if (state.auth) {
            state.auth = {...state.auth, freshTokenPromise: undefined};
        }
        
        // Note: application data is not persisted anymore for fresh starts
        // Other state will use default values from reducers
        
        return state;
    } catch(err) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        // Only persist authentication and essential data, not form data
        const stateToPersist = {
            auth: state.auth,
            loginState: state.loginState,
            customer: state.customer,
            // Don't persist application form data for fresh starts
            // application: state.application,
        };
        const serializedState = JSON.stringify(stateToPersist);
        localStorage.setItem('Kasvurahoitus', serializedState)
    } catch(err) {
        // sto: if it fails, dont worry
    }
};